import { useEffect, useState } from 'react';
import { Common, color } from '@stockbit/ui';
import object from 'utils/object';
import { IDataScreenerPreset } from 'features/screener/types';

import CloseIcon from '../Common/CloseIcon';
import { List } from '../styled';
import styled from 'styled-components';
import AutoSuggestion from './AutoSuggestion';

const { Text, Flex } = Common;

const ListDiv = styled.div`
  height: calc(100% - 40px);
  overflow: auto;
`;

interface PresetScreenerTypes {
  handlePresetScreener: () => void;
  dataPresetScreener: IDataScreenerPreset[];
  handleOnClickDetailPreset: (param: number) => void;
  maxAutocompleteHeight: string;
}

const PresetScreener = ({
  handlePresetScreener,
  dataPresetScreener,
  handleOnClickDetailPreset,
  maxAutocompleteHeight,
}: PresetScreenerTypes) => {
  const [listData, setListData] = useState([]);
  const [options, setOptions] = useState([]);

  const handleSelect = (data) => {
    // search value to dataPresetScreener & get array

    const { childs } = data;

    if (childs.length === 0) {
      // dispatch to API
      handleOnClickDetailPreset(data.id);
    }

    const selectedValue = [{ ...data }];

    // set to list Data
    setListData(selectedValue);
  };

  // seed data to state listData
  useEffect(() => {
    setListData(dataPresetScreener);
  }, [dataPresetScreener]);

  const handleOnClickSearch = (searchedId) => {
    // search value to dataPresetScreener & get array
    const findValueData: any = object.findNestedObj(listData, 'id', searchedId);

    const { childs } = findValueData;

    if (childs.length === 0) {
      // dispatch to API
      handleOnClickDetailPreset(searchedId);
    }

    // set childs to list Data
    setListData(childs);
  };

  const filterMetric = ({ keyword, data_metric, map_struc }) => {
    data_metric.map((item, i) => {
      if (item.childs && item.childs.length == 0) {
        if (item.name.toLowerCase().search(keyword.toLowerCase()) > -1) {
          map_struc.push(item);
        }
      } else {
        filterMetric({
          keyword: keyword,
          data_metric: item.childs,
          map_struc: map_struc,
        });
      }
    });
    return map_struc;
  };

  const onSearch = (e) => {
    const opts = filterMetric({
      keyword: e.target.value,
      data_metric: dataPresetScreener,
      map_struc: [],
    });

    setOptions(opts);
  };

  return (
    <ListDiv>
      <Flex
        p=" 5px 10px"
        align="center"
        justify="space-between"
        style={{ borderBottom: `1px solid ${color.gainsboro}` }}
      >
        <Text>Preset Screener</Text>
        <CloseIcon onClick={handlePresetScreener} />
      </Flex>
      <Flex p="10px">
        <AutoSuggestion
          options={options}
          onSelect={handleSelect}
          onSearch={onSearch}
          maxHeight={maxAutocompleteHeight}
        />
      </Flex>
      <div>
        {listData.map((preset) => (
          <List key={preset.id} onClick={() => handleOnClickSearch(preset.id)}>
            {preset.name}
          </List>
        ))}
      </div>
    </ListDiv>
  );
};

export default PresetScreener;
